import { createApp } from 'vue';
import App from './App.vue';
import axiosInstance from './plugins/axios';
import router from './router';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 创建应用实例
const app = createApp(App);

// 设置全局属性（例如，axios 实例）
app.config.globalProperties.$axios = axiosInstance;

// 使用路由（虽然这一步在 Vue Router 4 中是可选的，但明确调用也无妨）
app.use(router);
app.use(ElementPlus)

// 挂载应用
app.mount('#app');